import axios from "axios";

const baseURL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

// Debug once:
console.log("API BASE URL =", baseURL);

export const api = axios.create({ baseURL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("founder_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
